import * as Yup from 'yup';

export const addLevelSchema = Yup.object({
  description: Yup.string().required('Description is required'),
});
